// src/App.js

import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes
} from "react-router-dom";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./app/auth/authConfig"; // MSAL instance
import Login from "./app/auth/SigninWidget"; // Your login component
import useAutoLogout from "./app/auth/AutoLogout";
import Details from "./pages/Details/Details";
import Anonymized from "./pages/Anonymized/Anonymized";
import AIEmailIntegration from "./pages/AIEmailIntegration/AIEmailIntegration";
import RetailDisplayChecker from "./pages/RetailDisplayChecker/RetailDisplayChecker";
import Application from "./pages/Application/Application";
import EmailCompliance from "./pages/EmailCompliance/EmailCompliance";
import ToolDetails from "./pages/Details/ToolDetails";
import LandingPage from "./pages/AdminControl/LandingPage";
import CategoryManagementLandingPage from "./pages/AdminControl/CategoryManagementLandingPage";
import ToolManagementLandingPage from "./pages/AdminControl/ToolManagementLandingPage";
import NotificationManagementLandingPage from "./pages/AdminControl/NotificationManagementLandingPage";
import Dashboard from "./pages/AdminControl/Dashboard";
import { UserRoleProvider } from "./app/auth/useUserRole";


const App = () => {
  useAutoLogout(); // Automatically logs out after 5 minutes of inactivity

  return (
    <MsalProvider instance={msalInstance}>
      <UserRoleProvider>
        <Router>
        <Routes>
          <Route path="/" element={<Login />} /> {/* Home route */}
          {/* <Route path="/fileoutput" element={<Output />} />  */}
          <Route path="/details-email" element={<Details />} /> {/* Home route */}
          <Route path="/application" element={<Application />} /> {/* Home route */}
          <Route path="/details/:id" element={<ToolDetails />} />
          <Route path="/email" element={<EmailCompliance />} /> {/* Home route */}

          <Route path="/Anonymized" element={<Anonymized />} /> {/* Home route */}
          <Route path="/email-integrations" element={<AIEmailIntegration />} /> {/* Home route */}
          <Route path="/retailDisplayChecker" element={<RetailDisplayChecker />} /> {/* Home route */}
          <Route path="/admin/control/userManagement" element={<LandingPage />} /> 
          <Route path="/admin/control/toolregistraions" element={<ToolManagementLandingPage/>} /> 
          <Route path="/admin/control/catagorymanagement" element={<CategoryManagementLandingPage />} /> 
          <Route path="/admin/control/notificationmanagement" element={<NotificationManagementLandingPage />} /> 
          <Route path="/tool/report/:reportnewid" element={<Dashboard />} />

          {/* <Route
              path="/admin/control/userManagement"
              render={() => (
                <MainLayout>
                  <Index />
                </MainLayout>
              )}
            /> */}

        </Routes>
        </Router>
      </UserRoleProvider>
    </MsalProvider>
  );
};

export default App;
